import { Target, Users, Workflow, BarChart3 } from "lucide-react";

/** Structured landing-page details (industry / department / tool pages). */
export function LandingDetails({ landing }) {
  if (!landing) return null;
  const { primary_pain, primary_buyer, common_use_cases = [], metrics_to_measure = [] } = landing;
  if (!primary_pain && !primary_buyer && !common_use_cases.length && !metrics_to_measure.length) return null;

  return (
    <section className="my-8 grid gap-4 sm:grid-cols-2" data-testid="resource-landing">
      {primary_pain ? (
        <Block icon={Target} title="The problem">{primary_pain}</Block>
      ) : null}
      {primary_buyer ? (
        <Block icon={Users} title="Who it's for">{primary_buyer}</Block>
      ) : null}
      {common_use_cases.length ? (
        <Block icon={Workflow} title="Common use cases">
          <ul className="mt-1 list-disc space-y-1 pl-4">{common_use_cases.map((u, i) => <li key={i}>{u}</li>)}</ul>
        </Block>
      ) : null}
      {metrics_to_measure.length ? (
        <Block icon={BarChart3} title="Metrics to measure">
          <ul className="mt-1 list-disc space-y-1 pl-4">{metrics_to_measure.map((m, i) => <li key={i}>{m}</li>)}</ul>
        </Block>
      ) : null}
    </section>
  );
}

function Block({ icon: Icon, title, children }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5">
      <p className="flex items-center gap-2 text-sm font-semibold text-navy">
        <Icon className="h-4 w-4 text-editorial" /> {title}
      </p>
      <div className="mt-2 text-sm leading-relaxed text-slate-600">{children}</div>
    </div>
  );
}
